import { css } from "@/../styled-system/css";

const skeleton = {
  opacity: ".5",
  animation: "pulse",
  rounded: "md",
  backgroundColor: "gray.200",
};

function Skeleton({
  css: cssProp = {},
  ...props
}: { css?: object } & React.HTMLAttributes<HTMLDivElement>) {
  const className = css(skeleton, cssProp);
  return <div className={className} {...props} />;
}

export default Skeleton;
